import { render } from "./navbar.vue?vue&type=template&id=925947d8&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=925947d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-925947d8"

export default script